import { isEditorEmpty } from "../../common";

const isValidCallbackEmail = ({ block }: any) => {
    if (!block)
        return {
            isValid: true,
            error: "",
        };
    const {
        data: { text },
    } = block;
    return {
        isValid: !isEditorEmpty(text),
        error: <></>,
    };
};

export default isValidCallbackEmail;
